import React from 'react';
export default function MessageReadStatus({message}) {
  const viewed = Boolean(message.read_at);
  return <span className={`message-read-status${viewed ? ' is-viewed' : ''}`} title={viewed ? `Viewed ${new Date(message.read_at).toLocaleString()}` : 'Sent successfully. The recipient has not opened this message yet.'}><span aria-hidden="true">{viewed ? '✓✓' : '✓'}</span> {viewed ? 'Viewed' : 'Sent · Unread'}</span>;
}
